import type { CommonOptions, FormIncomeSimpleData, FormLoanSimpleData } from "bm-ui-kit";
import type { PersonalLoanLeadFormFields } from "../LeadForm";

export const EMPLOYMENT_TYPES: CommonOptions = [
	{ label: "Határozatlan idejű", value: "INDEFINITE" },
	{ label: "Határozott idejű", value: "DEFINITE" },
];

export interface PersonalLoanScoringRequest {
	birthYear: number;
	existingLoans: Record<string, number>;
	inKHR: boolean;
	incomeList: FormIncomeSimpleData[];
	pastMonthsSalaries: number[];
	calculationDate: string;
}
export interface PersonalLoanScoringResponseItem {
	apr: number;
	installment: number;
	loanAmount: number;
}
export interface PersonalLoanScoringResponseItemPair {
	0: PersonalLoanScoringResponseItem;
	1: PersonalLoanScoringResponseItem;
}

export interface PersonalLoanScoringResponse {
	messages: string[];
	availableLoans: PersonalLoanScoringResponseItemPair[];
}

export interface PersonalLoanScoringCalculatorFormFields extends PersonalLoanLeadFormFields {
	maturity: number;
	lastIncome1: number;
	lastIncome2: number;
	lastIncome3: number;
	receiptBank: string;
	employmentType: string;
	birthYear: number;
	existingLoans: FormLoanSimpleData[];
}
